<template lang="pug">
.target-pill
  i.target-pill-icon.hi.hi-info-filled.mr-5(
    v-if="tooltip"
    v-tooltip="tooltipOptions"
    :title="tooltip"
  )
  span.target-pill-label(:title="label")
    | {{ label }}:&nbsp;
  b.target-pill-value {{ value }}
  a.edit-link.ml-5(
    v-if="canEdit"
    :href="editHref"
    target="_blank"
    rel="noopener"
    aria-label="Edit work hours target"
  )
    i.edit-icon.hi.hi-edit
</template>

<script>
export default {
  name: 'InsightsUtilizationWidgetTargetPill',
  props: {
    period: { type: String, required: true }, // "Today's" / "Daily" / "Avg. daily" etc.
    value: { type: String, required: true },
    tooltip: { type: String, default: '' },
    canEdit: { type: Boolean, default: false },
    editHref: { type: String, default: '' },
  },
  data: () => ({
    tooltipOptions: Object.freeze({
      placement: 'top',
      html: true,
      sanitize: false,
    }),
  }),
  computed: {
    label() {
      return `${this.period} target`;
    },
  },
};
</script>
